import { render, staticRenderFns } from "./payment-success.vue?vue&type=template&id=f8d85edc&scoped=true&"
import script from "./payment-success.vue?vue&type=script&lang=js&"
export * from "./payment-success.vue?vue&type=script&lang=js&"
import style0 from "./payment-success.vue?vue&type=style&index=0&id=f8d85edc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8d85edc",
  null
  
)

export default component.exports